import { ResidentialUnitExtraData } from '@/types';

export enum ResidentialUnitViewMode {
    Compressed = 'compressed',
    Expanded = 'expanded',
}

interface CommonProps {
    hrefGenerator(residentialUnit: ResidentialUnitExtraData): string;
    notificationCountGetter?(residentialUnitId: number): number;
    onDelete(): void;
    onUpdate(): void;
    // Selection props
    selectedUnitIds?: number[];
    onUnitSelect?(unitId: number, selected: boolean): void;
}

export type ResidentialUnitListItemProps = CommonProps & {
    residentialUnit: ResidentialUnitExtraData;
};
export type ResidentialUnitListProps = CommonProps & {
    residentialUnits: ResidentialUnitExtraData[];
    viewMode?: ResidentialUnitViewMode;
};

export { default } from './ResidentialUnitList';